import { render } from "./icon-flask.vue?vue&type=template&id=657ef890"
import script from "./icon-flask.vue?vue&type=script&lang=js"
export * from "./icon-flask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__